import { RowNode } from 'ag-grid-community';
import { AgGridColumn } from 'ag-grid-react/lib/agGridColumn';
import React, { useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ConnectedHcpGridWithGQL, PrescriberSearchInput, ResourceContent } from '.';
import { usePhysiciansInfoQuery } from '../graphql';
import { AnyType } from '../interfaces';
import { AppRootState, navigateToPrescriberNew } from '../redux';
import {
  featureGridColumnsSelector,
  generalColumnDefinition,
  getFeatureGridColumnProps,
  getConfigurationDataKey,
  isEmptyObject,
  rawHtmlProps
} from '../utils';

const columnSelector = featureGridColumnsSelector(getConfigurationDataKey('prescribers.table'));

export const PrescribersTable = ({ searchValue }: { searchValue: string | undefined }) => {
  const verbiageText = useSelector(
    (state: AppRootState) =>
      (((state.app?.entities?.features as AnyType) ?? {})['account-administration-verbiage'] as AnyType)?.data || {}
  );

  const filterPrescribers = (node: RowNode, value: string | undefined) => {
    const { firstName = '', lastName = '', npi = '' } = node.data ?? {};
    const name = `${firstName} ${lastName}`.toLowerCase();
    const filterValue = (value ?? '').trim().toLowerCase();
    const npiLower = (npi ?? '').toLowerCase();
    return name.includes(filterValue) || npiLower.includes(filterValue);
  };

  const columns = useSelector(columnSelector);

  if (!columns) return null;

  return (
    <>
      <ConnectedHcpGridWithGQL
        queryHook={usePhysiciansInfoQuery}
        isFilterActive={!!searchValue}
        filterComparator={filterPrescribers}
        filterValue={searchValue}
        pagination>
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='firstName'
          {...getFeatureGridColumnProps(columns.firstName)}
        />
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='lastName'
          {...getFeatureGridColumnProps(columns.lastName)}
        />
        <AgGridColumn
          {...generalColumnDefinition()}
          resizable={true}
          field='npi'
          {...getFeatureGridColumnProps(columns.npi)}
        />
      </ConnectedHcpGridWithGQL>
      {!isEmptyObject(verbiageText) && (
        <span className='text-primary ag-theme-alpine' {...rawHtmlProps(verbiageText)} />
      )}
    </>
  );
};
